import {useEffect, useReducer} from "react"
import {TeamContext} from "../contexts/TeamContext"
import teamReducer from "../reducers/teamReducer"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    licencePackage: {},
    licenceTypes: [],
    licenceStartDate: null,
    licenceEndDate: null,
}

export default function TeamProvider({children}) {
    const [teamContext, setTeamAction] = useReducer(
        teamReducer,
        initialState,
        () => {
            try {
                const stored = localStorage.getItem("teamContext")
                return stored ? JSON.parse(stored) : initialState
            } catch (error) {
                console.error("Failed to parse teamContext from localStorage", error)
                return initialState
            }
        }
    )

    useEffect(() => {
        if (teamContext) {
            localStorage.setItem("teamContext", JSON.stringify(teamContext))
        } else {
            localStorage.removeItem("teamContext")
        }
    }, [teamContext])

    return (
        <TeamContext.Provider value={{teamContext, setTeamAction}}>
            {children}
        </TeamContext.Provider>
    )
}